<a *ngIf="isLink(item) && !isFunction(item.route) && roleValidation(item)"
   [fragment]="item.fragment"
   [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
   [routerLink]="item.route"
   class="item fx-row"
   matRipple
   routerLinkActive="active">
  <iconify-icon *ngIf="level === 0"[icon]="item.icon" class="item-icon fx-flex-none"></iconify-icon>
  <span class="item-label fx-flex-auto">{{ item.label }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="item-badge fx-flex-none">{{ item.badge.value }}</span>
</a>

<div (click)="item.route()"
     *ngIf="isLink(item) && isFunction(item.route) && roleValidation(item)"
     class="item fx-row"
     matRipple
     routerLinkActive="active">
  <iconify-icon *ngIf="level === 0" [icon]="item.icon"  class="item-icon fx-flex-none"></iconify-icon>
  <span class="item-label fx-flex-auto">{{ item.label }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="item-badge fx-flex-none">{{ item.badge.value }}</span>
</div>

<ng-container *ngIf="isDropdown(item) && roleValidation(item)" (mouseleave)="toggleOpen()">
  <div (click)="onClick(item.route)" (mouseenter)="toggleOpen()"  
       [class.active]="isOpen || isActive"
       [class.open]="isOpen"
       class="item fx-row"
       routerLinkActive="active"
       matRipple>
    <iconify-icon *ngIf="level === 0" [icon]="item.icon" class="item-icon fx-flex-none"></iconify-icon>
    <span class="item-label fx-flex-auto">{{ item.label }}</span>
    <span *ngIf="item.badge"
          [ngClass]="[item.badge.bgClass, item.badge.textClass]"
          class="item-badge fx-flex-none">{{ item.badge.value }}</span>
    <iconify-icon [icon]="icKeyboardArrowRight" class="item-dropdown-icon fx-flex-none"></iconify-icon>
  </div>
  <div [@dropdown]="isOpen" class="item-dropdown">
    <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="level + 1"></vex-sidenav-item>
  </div>
</ng-container>


<ng-container *ngIf="isSubheading(item) && roleValidation(item)">
  <div class="subheading">{{ item.label }}</div>
  <vex-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="0"></vex-sidenav-item>
</ng-container>

